import { GetStorageItemType, SetStorageItemType } from '@/types/storage';

export class Storage {
  static getItem: GetStorageItemType;
  static setItem: SetStorageItemType;

  static init = (
    getStorageItemType: GetStorageItemType,
    setStorageItemType: SetStorageItemType,
  ) => {
    Storage.getItem = getStorageItemType;
    Storage.setItem = setStorageItemType;
  };
}
